import { render } from "./DettaglioOda.vue?vue&type=template&id=8aa4bc7e&scoped=true&ts=true"
import script from "./DettaglioOda.vue?vue&type=script&lang=ts"
export * from "./DettaglioOda.vue?vue&type=script&lang=ts"

import "./DettaglioOda.vue?vue&type=style&index=0&id=8aa4bc7e&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8aa4bc7e"]])

export default __exports__